import { useMemo } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface LockedAccountAlertProps {
    isAlertPopup: boolean
}

function LockedAccountAlert(props: LockedAccountAlertProps): JSX.Element {
    const { isAlertPopup } = props;
    const { getText } = useTranslation();

    const failedLabel = "PortalInvitation_RegistrationFailedLabel";
    const lockedLabel = "PortalInvitation_RegistrationHenceLockedLabel";
    const unlockLabel = "PortalInvitation_RegistrationUnlockLabel";
    const popupNoteLabel = "PortalInvitation_RegistrationPopupNoteLabel";

    const getInviteNote = useMemo(
        () => `${getText(failedLabel)} ${getText(lockedLabel)}`.replace(/(<([^>]+)>)/gi, ""),
        [getText]
    );

    return isAlertPopup ? (
        <>
            <p className="red-text" dangerouslySetInnerHTML={{ __html: getText(failedLabel) }} />
            <p className="margin-md-bottom red-text" dangerouslySetInnerHTML={{ __html: getText(lockedLabel) }} />
            <p>{getText(unlockLabel)}</p>
        </>
    ) : (
        <>
            <p className="margin-md-bottom">{getInviteNote}</p>
            <p className="margin-md-bottom red-text">{getText(popupNoteLabel)}</p>
        </>
    );
}

export { LockedAccountAlert };
